import { MobileMenu } from './mobile-menu'
import { UserMenu } from './user-menu'
import { SearchButton } from '@/features/search/ui/search-button'
import { SearchModal } from '@/features/search/ui/search-modal'
import { NotificationCenter } from '@/features/notifications/ui/notification-center'

const Header = () => (
	<header className='md:m-0 z-50 px-6 md:border-b h-17.5 flex justify-between items-center top-0 bg-background'>
		<MobileMenu />
		<SearchButton />
		<div className='flex items-center gap-2 ml-auto'>
			<NotificationCenter />
			<UserMenu />
		</div>
		<SearchModal />
	</header>
)

export { Header }
